// 登录
export function login(_ref) {
  var loginUrl = _ref.loginUrl,
      env = _ref.env,
      _ref$testPassportUrl = _ref.testPassportUrl,
      testPassportUrl = _ref$testPassportUrl === void 0 ? 'https://passport.fanruan.com' : _ref$testPassportUrl,
      _ref$prodPassportUrl = _ref.prodPassportUrl,
      prodPassportUrl = _ref$prodPassportUrl === void 0 ? 'https://fanruanclub.com' : _ref$prodPassportUrl;

  if (loginUrl) {
    window.location.href = loginUrl;
  } else {
    var now_url = window.location.href;
    var passportUrl = env === 'test' ? testPassportUrl : prodPassportUrl;
    var fanruanSplitArray = now_url.split('fanruan.com');
    var onlyRouter = '/';

    if (Array.isArray(fanruanSplitArray) && fanruanSplitArray.length > 1) {
      var withoutHost = fanruanSplitArray[1];
      onlyRouter = withoutHost.split('?')[0];
    }

    window.location.href = "".concat(passportUrl, "/cas/login?service=").concat(window.location.origin, "/server/login/cas?redirect=").concat(onlyRouter);
  }
} // 头像

export function userAvatar(uid) {
  var size = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'small';
  return "https://bbs.fanruan.com/uc_server/avatar.php?uid=".concat(uid, "&size=").concat(size);
} // 区分是pc还是mobile

export function isMobile() {
  return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
} // 写入 Cookie

export function setCookie(name, value) {
  //设置名称为name,值为value的Cookie
  var expdate = new Date(); //初始化时间

  expdate.setTime(expdate.getTime() + 30 * 60 * 1000); //时间

  document.cookie = name + '=' + value + ';SameSite=None;Secure;expires=' + expdate.toUTCString() + ';path=/'; //即document.cookie= name+"="+value+";path=/"; 时间可以不要，但路径(path)必须要填写，因为JS的默认路径是当前页，如果不填，此cookie只在当前页面生效！~
} // 获取 Cookie

export function getCookie(c_name) {
  if (document.cookie.length > 0) {
    var c_start = document.cookie.indexOf(c_name + '=');

    if (c_start !== -1) {
      c_start = c_start + c_name.length + 1;
      var c_end = document.cookie.indexOf(';', c_start);
      if (c_end === -1) c_end = document.cookie.length;
      return unescape(document.cookie.substring(c_start, c_end));
    }
  }

  return '';
} // 清空 Cookie

export function clearCookie() {
  var keys = document.cookie.match(/[^ =;]+(?==)/g);

  if (keys) {
    for (var i = keys.length; i--;) {
      document.cookie = keys[i] + '=0;path=/;expires=' + new Date(0).toUTCString();
    }
  }
}
export function delCookie(name) {
  var exp = new Date();
  exp.setTime(exp.getTime() - 1);
  var cval = getCookie(name);
  if (cval !== null) document.cookie = name + '=' + cval + ';expires=' + exp.toUTCString() + ';path=/';
}
export var generateRandomStr = function generateRandomStr() {
  return Math.random().toString(36).slice(-8);
};